<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Life LMS table</h6>
      </div>
      <div class="float-end">
        <div class="row">
          <!-- <div class="col-12">
            <div class="input-group mb-3">
              <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari" name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari">
              <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%;" type="button" id="cari" @click="cari"><i class="fas fa-search"></i></button>
            </div>
          </div> -->
          <!-- <div class="col-6"> -->
            <!-- Button to open the modal -->
            <!-- <button class="btn btn-sm btn-dark me-2" @click="showModal = true">
              <i class="fa fa-plus"></i> Add life_at_talent
            </button> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{alertstatus}}</strong> {{alerttext}}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Content
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Action
              </th>
              
            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>
                <div v-html="item.content"></div>
              </td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i class="fa fa-edit"></i></button>
                <!-- <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i class="fa fa-trash"></i></button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item 
            prev  
            :disabled="currentPage === 1" 
            @click="prevPage"
          />
          
          <!-- Page Numbers -->
          <argon-pagination-item 
            v-for="page in totalPages" 
            :key="page" 
            :label="String(page)" 
            :active="currentPage === page" 
            @click="setPage(page)"
          />
          
          <!-- Next Page Button -->
          <argon-pagination-item 
            next  
            :disabled="currentPage === totalPages" 
            @click="nextPage"
          />
        </argon-pagination>
      </div>
      
      <div :class="showModal == true ? 'modal-backdrop': '' "></div>
      <div class="modal fade" :class="showModal == true ? 'show': '' " tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add' ">Add New life_at_talent</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit life_at_talent</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3">
                  <label for="content" class="form-label">Content</label>
                  <QuillEditor 
                      theme="snow" 
                      v-model:content="formData.content"
                      contentType="html"
                      class="large-editor"
                    />
                    <small class="text-danger">*Tambahkan https:// jika itu link</small>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
  
</template>
<script>
import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
export default {
  data() {
    return {
      life_at_talentList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage:10,
      sortOrder: 'asc',
      searchQuery: '',
      showModal: false, // Controls modal visibility
      formData: {
        title: '',
        file: null,
      },
      method: 'add',
      alertstatus: null,
      alerttext: null
    };
  },
  components: {
   ArgonPagination,
   ArgonPaginationItem,
   ArgonAlert,
   QuillEditor
   },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchlife_at_talentList();
  },
  computed: {
    totalItems() {
      return this.life_at_talentList.length;
    },
    paginatedData() {
      return this.life_at_talentList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchlife_at_talentList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "https://api-profile.productscala.online/admin/life_at_talent",
        params: {
          sort: this.sortOrder,
          limit: this.itemsPerPage,
          paginate: this.currentPage,
          key_search: this.searchQuery
        },
        headers: {
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
      };

      await axios
        .request(config)
        .then((response) => {   
          if (response.data?.message == 'success') {
            this.life_at_talentList = [response?.data?.data]; // Assign banner_list to local data
            this.totalPages = 1 // Update the total number of pages (this depends on how the API returns pagination info)
          }else{
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchlife_at_talentList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchlife_at_talentList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchlife_at_talentList();
    },
    updateItemsPerPage() {
      this.fetchlife_at_talentList();
    },
    updatesoftby(){
      this.fetchlife_at_talentList();
    },
    cari(){
      this.fetchlife_at_talentList();
    },
    closeModal() {
      this.showModal = false;
      // Reset form data
      this.formData = {
        title: '',
        file: null,
      };
      this.method = 'add';
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    handleFileUpload(event) {
      this.formData.file = event.target.files[0]; // Capture the file
    },
    async submitForm() {
      let access_token = localStorage.getItem('access_token');
      var data = {};
      var config = {}
      if (this.method == 'add') {
        data.append('title', this.formData.title);
        data.append('file', this.formData.file);

        config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/life_at_talent',
        headers: { 
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
        data: data,
        };
      }else{
        data = {
          'content' : this.formData.content 
        };

        config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/life_at_talent',
        headers: { 
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
        data: data,
        }
      }
      
      try {
        const response = await axios.request(config);
        if (response.data?.message == 'success') {
          this.fetchlife_at_talentList();
          if (this.method == 'add') { 
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success"
            });
          }else{
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success"
            });
          }
          this.closeModal(); // Close modal after successful submission
        }else{
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
        console.log(response.data);
      } catch (error) {
        var err = error.response.data.message
        this.alertstatus = 'danger';
        this.alerttext = err
        console.error("Error fetching data:", error);
      }
    },

    async hapus(id) {
      let access_token = localStorage.getItem('access_token');
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/life_at_talent/' + id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          }
        };

        try {
          const response = await axios.request(config);
          if (response.data?.message == 'success') {
            await this.fetchlife_at_talentList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },

    edit (item) {
      this.formData = {
        content: item.content,
        id: item.id 
      };
      this.showModal = true;
      this.method = 'edit';
    }

  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block; /* Override display to block */
}
.modal-backdrop {
  opacity: 50%;
}
</style>